import React, { useState } from "react";
import "./index.css";
import {
  Box,
  Container,
  Stack,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Divider,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const faqData = [
  {
    heading: "What business structures do you provide services for?",
    description:
      "We offer tax, bookkeeping, accounting, and advisory services to individuals, sole traders, partnerships, companies, and trusts. No matter your business structure, we ensure full compliance and support your financial growth.",
  },
  {
    heading: "What bookkeeping services do you offer for small businesses?",
    description:
      "We provide tailored bookkeeping solutions for small businesses, including BAS lodgement, accounts payable and receivable, bank reconciliations, payroll processing, and financial reporting to keep your financial records accurate and up to date.",
  },
  {
    heading: "How can your tax services help me save money?",
    description:
      "Our expert tax preparation and planning services help maximize deductions and minimize liabilities. We stay updated with the latest tax laws to ensure compliance while identifying valuable opportunities to save you money.",
  },
  {
    heading: "Why is accurate bookkeeping important for tax filing?",
    description:
      "Accurate bookkeeping ensures error-free tax filing by keeping your financial records organized and compliant with ATO regulations. It reduces audit risks and provides real-time insights into your business’s financial health.",
  },
  {
    heading: "Do you provide virtual bookkeeping services?",
    description:
      "Yes. Our cloud-based virtual bookkeeping allows you to access your financial records anytime, anywhere—making it ideal for remote teams and busy business owners.",
  },
  {
    heading: "Is your service available Australia-wide?",
    description:
      "Yes. Aspire Tax and Bookkeeping serves clients across all Australian states and territories, offering expert bookkeeping and tax solutions tailored to national and local regulations.",
  },
  {
    heading: "How do I get started with your services?",
    description:
      "Getting started is easy. Contact us through our website, book a free consultation, and we’ll discuss your requirements to create a tailored service package for you.",
  },
];

function Faq() {
  // State to track which panel is expanded (using index)
  const [expanded, setExpanded] = useState(0); // Default to first panel open

  // Handler for accordion change
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : -1);
  };

  return (
    <>
      <Container maxWidth="xl" sx={{ my: 5, p:0 }}>
        <Box>
          <Typography className="faq-heading">
            Frequently Asked Questions About Our Bookkeeping & Tax Services
          </Typography>
          <Typography className="faq-description">
            Find quick answers to common questions about our bookkeeping, BAS, payroll, and advisory solutions 
            for individuals and businesses across Australia.
          </Typography>

          <Divider className="faq-divider" />

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            className="faq-section"
            sx={{ alignItems: "stretch" }}
          >
            <Box sx={{ flex: 1 }}>
              {faqData.map((item, index) => (
                <Accordion
                  key={index}
                  expanded={expanded === index}
                  onChange={handleChange(index)}
                  className="faq-desktop"
                >
                  <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls={`panel${index + 1}-content`}
                    id={`panel${index + 1}-header`}
                    sx={{ padding: 0 }}
                  >
                    <Typography component="span" className="accordian-heading">
                      {item.heading}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ paddingLeft: 0, paddingRight:0 }}>
                    <Typography className="accordian-description">
                      {item.description}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
            <Box
              className="faq-image-box"
              sx={{ flex: 1, display: "flex", justifyContent: "center" }}
            >
              <img src="/assets/faq.webp" alt="Faq" className="faq-image" />
            </Box>
          </Stack>
        </Box>
      </Container>
    </>
  );
}

export default Faq;